import {get, post, listAll} from './utils';

const dao = {
  queryProduct: productId =>
    get('/smb-backend/product/query-product.action', {productId}),
  listProducts: params =>
    get('/smb-backend/product/list-products.action', params),
  listAllProducts: params => listAll(dao.listProducts, params),
  createProduct: params =>
    post('/smb-backend/product/create-product.action', params),
  updateProduct: params =>
    post('/smb-backend/product/update-product.action', params),
  deleteProduct: productId =>
    get('/smb-backend/product/delete-product.action', {productId}),
  existProductNo: (productId, productNo) =>
    get('/smb-backend/product/exist-product-no.action', {productId, productNo}),
  updateProductOrder: params =>
    post('/smb-backend/product/update-product-order.action', params),
  listProductSkuIds: () => post('/smb-backend/product/list-sku-ids.action'),
  enableProduct: productId => 
    get('/smb-backend/product/enable-product.action', {productId}),
  disableProduct: productId => 
    get('/smb-backend/product/disable-product.action', {productId})
};

export default dao;
